import React, { useCallback, useEffect, useState, useRef, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function ImageSlider() {
  const images = ['https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-20_at_13.29.18_2_1.webp?v=1771603087', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-20_at_13.29.19_1_1_1.webp?v=1771603021', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-20_at_13.29.23_1.webp?v=1771602856', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-20_at_13.29.19_1.webp?v=1771602826', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-20_at_13.29.18_1_1_1.webp?v=1771602796', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-20_at_13.29.18_1.webp?v=1771602750', 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-20_at_13.29.17_1.webp?v=1771602727'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const autoplayRef = useRef<NodeJS.Timeout | null>(null);
  // Navigation functions
  const goToSlide = useCallback((index: number) => {
    setCurrentIndex(index);
  }, []);
  const goToNext = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  }, [images.length]);
  const goToPrev = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  }, [images.length]);
  // Autoplay logic
  useEffect(() => {
    if (!isHovered) {
      autoplayRef.current = setInterval(goToNext, 4000);
    }
    return () => {
      if (autoplayRef.current) {
        clearInterval(autoplayRef.current);
      }
    };
  }, [isHovered, goToNext]);
  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft') {
        goToPrev();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [goToNext, goToPrev]);
  // Touch/swipe handlers
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const minSwipeDistance = 50;
    if (distance > minSwipeDistance) {
      goToNext();
    } else if (distance < -minSwipeDistance) {
      goToPrev();
    }
    setTouchStart(0);
    setTouchEnd(0);
  };
  return <section className="py-8 md:py-16 px-4 bg-metal" data-id="element-126">
      <div className="max-w-5xl mx-auto" data-id="element-127">
        {/* Section Title */}
        <h2 className="text-2xl md:text-4xl font-black text-[#E4D6B5] uppercase tracking-tight text-center mb-6 md:mb-10" data-id="element-128">
          Lo Que Dicen Quienes Ya Lo Compraron
        </h2>
        {/* Carousel Container with Arrows in Side Rails */}
        <div className="flex items-center gap-4 md:gap-6" data-id="element-129">
          {/* Left Arrow - Outside Image */}
          <button onClick={goToPrev} aria-label="Imagen anterior" className="flex-shrink-0 bg-[#111111] hover:bg-[#1a1a1a] text-[#E4D6B5] p-3 md:p-4 rounded-full border-2 border-[#6F6F6F] transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#8B5A2B]" data-id="element-130">
            <ChevronLeft className="w-6 h-6 md:w-8 md:h-8" data-id="element-131" />
          </button>

          {/* Image Container */}
          <div className="flex-1" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-132">
            {/* Slides Container - NO top crop, only bottom crop */}
            <div className="relative w-full overflow-hidden rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.6)] bg-[#111111]" data-id="element-133">
              {/* Aspect ratio container - adjusted to show full top, crop bottom */}
              <div className="relative w-full" style={{
              paddingBottom: '155%'
            }} data-id="element-134">
                {images.map((image, index) => <div key={index} className="absolute top-0 left-0 w-full h-full transition-opacity duration-500 ease-in-out overflow-hidden" style={{
                opacity: currentIndex === index ? 1 : 0,
                pointerEvents: currentIndex === index ? 'auto' : 'none'
              }} data-id="element-135">
                    <img src={image} alt={`Testimonio ${index + 1}`} className="absolute w-full object-cover" style={{
                  height: '125%',
                  top: '0',
                  left: '0'
                }} loading="lazy" decoding="async" width="600" height="900" data-id="element-136" />
                  </div>)}
              </div>
            </div>
          </div>

          {/* Right Arrow - Outside Image */}
          <button onClick={goToNext} aria-label="Siguiente imagen" className="flex-shrink-0 bg-[#111111] hover:bg-[#1a1a1a] text-[#E4D6B5] p-3 md:p-4 rounded-full border-2 border-[#6F6F6F] transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#8B5A2B]" data-id="element-137">
            <ChevronRight className="w-6 h-6 md:w-8 md:h-8" data-id="element-138" />
          </button>
        </div>

        {/* Dots Navigation - Below Image */}
        <div className="flex justify-center gap-2 mt-6" data-id="element-139">
          {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} aria-label={`Ir a imagen ${index + 1}`} className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#8B5A2B] ${currentIndex === index ? 'bg-[#8B5A2B] w-6 md:w-8' : 'bg-[#6F6F6F] hover:bg-[#8B5A2B]/50'}`} data-id="element-140" />)}
        </div>

        {/* Slide Counter - Below Dots */}
        <div className="text-center mt-3" data-id="element-141">
          <p className="text-sm text-[#C8B894] font-semibold" data-id="element-142">
            {currentIndex + 1} / {images.length}
          </p>
        </div>
      </div>
    </section>;
}